module.exports = __webpack_public_path__ + "img/aptos.1df44b01.png";